import React from "react";
import Header from "./Header";
import Code from "./Code";
import Result from "./Result";

function Home() {
    return (
        <>
            <Header />
            <Code />
            <Result/>
        </>
    );
}

export default Home;
